import React, { useMemo, type FC } from 'react'
import {
  Panel,
  Link,
  LINK_VARIANT_DEFAULT,
  RadioButtonsGroup,
  Flex,
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { filterFormImmerAtom } from '../state/state'
import { useAtom } from 'jotai'
import Condition from './Condition'
import { ActionType } from '../../../types/FilterCondition'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type IconProp } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faClose } from 'mailup-fontawesome-kit/classic/regular'
import { actionTypeOptions } from '../utils/conditionOptions'
import { getEmptyCondition } from '../utils/conditionUtils'

const StyledPanel = styled(Panel)`
  background-color: #f5f5f5 !important;
` // FIXME: find a way to not use important, update styled?

interface ConditionsBlockProps {
  blockIndex: number
}

const ConditionsBlock: FC<ConditionsBlockProps> = ({ blockIndex }) => {
  const intl = useIntl()
  const [filter, setFilter] = useAtom(filterFormImmerAtom)
  const block = filter.Blocks[blockIndex]

  const actionTypeItems = useMemo(() => actionTypeOptions(intl), [intl])

  const deleteBlock = (): void => {
    setFilter((draft) => {
      if (blockIndex === 0 && draft.Blocks.length > 1) {
        draft.Blocks[1].JoinType = ActionType.Nil
      }
      draft.Blocks.splice(blockIndex, 1)
    })
  }
  const addCondition = (): void => {
    setFilter((draft) => {
      const conditions = draft.Blocks[blockIndex].Conditions
      conditions.push(getEmptyCondition(conditions.length))
    })
  }
  const changeActionType = (value: ActionType): void => {
    setFilter((draft) => {
      draft.Blocks[blockIndex].JoinType = value
    })
  }

  return (
    <>
      {blockIndex !== 0 && (
        <Flex flexDirection='row' justifyContent='center'>
          <RadioButtonsGroup
            items={actionTypeItems}
            value={block.JoinType}
            onChange={changeActionType}
            name={`actionTypes_block-${blockIndex}`}
          />
        </Flex>
      )}
      <StyledPanel margin='24px 0px 24px 0px'>
        {blockIndex !== 0 && (
          <Flex flexDirection='row' justifyContent='end' margin='0px 0px 24px'>
            <FontAwesomeIcon
              icon={faClose as IconProp}
              cursor='pointer'
              data-mu-test='block-delete'
              onClick={deleteBlock}
            />
          </Flex>
        )}
        {block.Conditions.map((_, i) => (
          <Condition
            key={`condition_${blockIndex}_${i}`}
            blockIndex={blockIndex}
            condIndex={i}
          />
        ))}
        <Link onClick={addCondition} variant={LINK_VARIANT_DEFAULT}>
          <FontAwesomeIcon
            icon={faPlus as IconProp}
            cursor='pointer'
            data-mu-test='condition-add'
          />
          {' ' +
            intl.formatMessage({
              id: 'Load.CombinedFilterForm.AddCondition',
            })}
        </Link>
      </StyledPanel>
    </>
  )
}

export default ConditionsBlock
